import React, { Suspense } from 'react';
import { lazyWithRetry } from '../../../utils/lazyWithRetry';
import type Model3DViewer from './Model3DViewer';

/**
 * Lazy entry point for the 3D viewer — this is what usage sites (preview modal,
 * etc.) should import. Keeping the `lazyWithRetry()` call in one module means the
 * viewer chunk (which pulls in `@google/model-viewer`) is code-split exactly once
 * and never enters the bundle of a page that has no 3D content.
 */
const LazyViewer = lazyWithRetry(() => import('./Model3DViewer'));

type Model3DViewerProps = React.ComponentProps<typeof Model3DViewer>;

export default function LazyModel3DViewer(props: Model3DViewerProps) {
  return (
    <Suspense
      fallback={
        <div
          data-testid="model3d-chunk-loading"
          className="w-full h-full flex items-center justify-center"
        >
          <div className="animate-spin rounded-full border-2 border-purple-500 border-t-transparent w-10 h-10" />
        </div>
      }
    >
      <LazyViewer {...props} />
    </Suspense>
  );
}
